var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActivity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 21.75C8.85193 21.7493 8.70739 21.7047 8.5846 21.622C8.46181 21.5392 8.36626 21.422 8.31 21.285L4.7475 12.75H1.5V11.25H5.25C5.39807 11.2507 5.54261 11.2953 5.6654 11.378C5.78819 11.4608 5.88373 11.578 5.94 11.715L9 18.96L15.045 2.7375C15.0986 2.59395 15.195 2.47028 15.321 2.38312C15.447 2.29596 15.5968 2.24951 15.75 2.25C15.9047 2.25271 16.0547 2.30316 16.1796 2.39447C16.3044 2.48577 16.398 2.61344 16.4475 2.76L19.29 11.25H22.5V12.75H18.75C18.5928 12.7504 18.4394 12.7014 18.3115 12.6099C18.1837 12.5184 18.0878 12.389 18.0375 12.24L15.75 5.25L9.705 21.2625C9.65137 21.4061 9.55505 21.5297 9.429 21.6169C9.30296 21.704 9.15324 21.7505 9 21.75Z",
    fill: "#265EA7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivity);
export default __webpack_public_path__ + "static/media/Activity.ee2a0ef87e33c5bb4da9efd07e6467a6.svg";
export { ForwardRef as ReactComponent };